import React, { ReactNode } from 'react';
import { InfoSection } from '../InfoSection';
import StepCompletedEmptyBlob from '../StepCompletedEmptyBlob';
import StepCompletedFilledBlob from '../StepCompletedFilledBlob';

interface Props {
  actionsSection: ReactNode;
  documentsList: ReactNode;
  stepIsCompleted: boolean;
  hasOneOrMoreDocuments: boolean;
  uncompleteStep: () => Promise<void>;
}

export const DocumentsBodyLayout: React.FC<Props> = ({
  actionsSection,
  documentsList,
  stepIsCompleted,
  hasOneOrMoreDocuments,
  uncompleteStep,
}) => {
  const renderCompletedSection = (): ReactNode => {
    if (hasOneOrMoreDocuments) {
      return (
        <>
          <StepCompletedFilledBlob uncompleteStep={uncompleteStep} />
          {documentsList}
        </>
      );
    }
    return <StepCompletedEmptyBlob uncompleteStep={uncompleteStep} />;
  };

  return (
    <>
      {!stepIsCompleted && hasOneOrMoreDocuments && <InfoSection />}
      {actionsSection}
      {stepIsCompleted ? renderCompletedSection() : documentsList}
    </>
  );
};
